import {env} from "../../../res/config/env";
import {useNavigate} from "react-router-dom";
import ComponentRenderer from "../../../newStructure/core/ComponentRenderer";

const logoStyle = {
    width: 206,
    height: "auto"
}


const DefaultLogo = () => {

    const navigate = useNavigate();

    const goToHome = () => {
        navigate("/");
    }

    return (
        <div className="logo-container" style={logoStyle}>
            <img src={env.CLIENT_LOGO + "logoWithText.svg"} alt="logo" onClick={goToHome}/>
        </div>
    )
}

const Logo = () => {
    return <ComponentRenderer defaultComponent={DefaultLogo} componentName="logo" />
}

export default Logo;
